<template>
    <div class="page">
      The page you are looking for cannot be found. Please return to the 
      <router-link to="/">
          word validator
    </router-link>.

    </div>
</template>

<script>
    export default {
    name: "PageNotFound",
    }
</script>

<style scoped>
    .class {
        font-size: x-large;
    }
</style>